import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { defineComponent, h } from 'vue';
import { Menu as AMenu } from 'ant-design-vue';
import Abstract from '../abstract';
var AMenuItem = AMenu.Item,
  ASubMenu = AMenu.SubMenu;
export default defineComponent({
  name: 'Contextmenu',
  extends: Abstract,
  components: {
    AMenu: AMenu,
    ASubMenu: ASubMenu,
    AMenuItem: AMenuItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['update:visible', 'select'],
  data: function data() {
    return {
      className: 'contextmenu',
      left: 0,
      top: 0,
      target: null,
      meta: null
    };
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('select', e.key, this.target, this.meta);
      this.closeMenu();
    },
    closeMenu: function closeMenu() {
      this.$emit('update:visible', false);
    },
    setPosition: function setPosition(e) {
      this.left = e.clientX;
      this.top = e.clientY;
      this.target = e.target;
      this.meta = e.meta;
    }
  },
  created: function created() {
    window.addEventListener('click', this.closeMenu);
    window.addEventListener('contextmenu', this.setPosition);
  },
  beforeUnmount: function beforeUnmount() {
    window.removeEventListener('click', this.closeMenu);
    window.removeEventListener('contextmenu', this.setPosition);
  },
  render: function render() {
    var menuList = this.menuList,
      prefixCls = this.prefixCls,
      left = this.left,
      top = this.top,
      visible = this.visible;
    var itemProps = {
      class: prefixCls + '-item'
    };
    var itemList = menuList.map(function (item) {
      var Icon = h(item.icon);
      return h(AMenuItem, _objectSpread(_objectSpread({}, itemProps), {}, {
        key: item.key
      }), function () {
        return [h(Icon, {
          class: prefixCls + '-item-icon'
        }), item.title];
      });
    });
    var menuProps = {
      onClick: this.handleClick,
      selectedKeys: [],
      class: prefixCls,
      style: "left: ".concat(left, "px; top: ").concat(top, "px; display: ").concat(visible ? '' : 'none')
    };
    return h(AMenu, menuProps, function () {
      return itemList;
    });
  }
});